import { getGroupIdFromTableQuery, isGroupTableQuery, lazyIsGroupOwner } from 'owa-group-utils';
import { MailRowDataPropertyGetter, TableView } from 'owa-mail-list-store';
import { doesUserHaveSharedFolderPermissionFor, MenuItemType } from '../index';

export default function shouldAllowDelete(tableView: TableView, rowKey?: string): boolean {
    // Deletion is disabled in a shared folder and user doesn't have delete permissions
    if (!doesUserHaveSharedFolderPermissionFor(MenuItemType.Delete)) {
        return false;
    }

    const tableQuery = tableView.tableQuery;

    if (isGroupTableQuery(tableQuery) && rowKey) {
        const isGroupOwner = lazyIsGroupOwner.tryImportForRender();
        if (
            !isGroupOwner?.(getGroupIdFromTableQuery(tableQuery)) &&
            !MailRowDataPropertyGetter.getCanDelete(rowKey, tableView)
        ) {
            return false;
        }
    }

    return true;
}
